export default __webpack_public_path__ + "static/media/kitchenqrbg.05aa3d09.png";